import content from "./content.json";
import useDocumentMeta from "../components/useDocumentMeta";

/**
 * Applies the title/description/canonical for a route from content.json —
 * the same file scripts/prerender.js reads at build time.
 *
 * The prerendered HTML already carries these tags, but the SPA swaps them out
 * on client-side navigation. Without this, every route a user reaches by
 * clicking (rather than by hard load) reverts to the homepage's title and
 * canonical, which is what the audit flagged as duplicate titles across all
 * six indexable pages.
 */
export default function useSeo(path) {
  const page = content.pages.find((p) => p.path === path);
  const url = content.site.url + (path === "/" ? "/" : path);

  useDocumentMeta({
    title: page?.title,
    description: page?.description,
    ogTitle: page?.title,
    ogDescription: page?.description,
    ogUrl: url,
    canonical: url,
  });
}
